import { v4 as uuidv4 } from 'uuid';
import { formatDate } from 'utils/commonUtils';
import { ActionWrapperBox } from 'components/Common/common.styled';
import {
  ButtonIcon,
  RoundedIconCloudDownload,
  DeleteActionIcon,
} from 'components/Ui/styled';

const renderEmployeeDocumentActions = (
  params,
  handleDownloadEmployeeDocument,
  handleDeleteEmployeeDocument
) => {
  return (
    <ActionWrapperBox>
      <ButtonIcon
        onClick={() => handleDownloadEmployeeDocument(params)}
        data-testid="buttonIcon"
      >
        <RoundedIconCloudDownload />
      </ButtonIcon>
      <ButtonIcon
        onClick={() => handleDeleteEmployeeDocument(params)}
        data-testid="deleteButtonIcon"
      >
        <DeleteActionIcon />
      </ButtonIcon>
    </ActionWrapperBox>
  );
};

export const employeeDocumentsColumns = (
  handleDownloadEmployeeDocument,
  handleDeleteEmployeeDocument
) => [
  {
    field: 'action',
    headerName: 'Action',
    sortable: false,
    disableColumnMenu: true,
    width: 80,
    renderCell: (params) =>
      renderEmployeeDocumentActions(
        params,
        handleDownloadEmployeeDocument,
        handleDeleteEmployeeDocument
      ),
  },
  { headerName: 'File Name', field: 'filename', flex: 1 },
  {
    headerName: 'Size',
    field: 'size',
    flex: 1,
  },
  { headerName: 'Friendly Size', field: 'friendlySize', flex: 1 },
  { headerName: 'Uploaded At', field: 'uploadedAt', flex: 1 },
];

export const getEmployeeDocumentsListData = (employeeDocumentsData) => {
  const documents = employeeDocumentsData?.documents;
  if (!documents || documents.length === 0) {
    return [];
  }
  return documents.map((item) => ({
    ...item,
    id: uuidv4(),
    filename: item.filename,
    size: item.size,
    friendlySize: item.friendlySize,
    uploadedAt: formatDate(item.uploadedAt),
  }));
};
